/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './video.defs.js'
export { main as default } from './video.defs.js'
